import { Button, NineSliceContainer } from "@ravalmatic/catafractum-utils";
import { GameVars } from "../../GameVars";
import type { ContractResultData } from "./BoardManager";
import { ContractBid } from "./bidding-menu/ContractBid";

export class ContractResult extends Phaser.GameObjects.Container {

    private static readonly WIDTH = 560;
    private static readonly HEIGHT = 450;

    private readonly backdrop: Phaser.GameObjects.Rectangle;
    private readonly panel: Phaser.GameObjects.Container;
    private readonly continueBtn: Button;

    constructor(scene: Phaser.Scene, result: ContractResultData, onContinue: () => void, matchFinished = false) {

        super(scene);
        this.setDepth(2000);
        this.backdrop = new Phaser.GameObjects.Rectangle(
            scene, 0, 0, GameVars.gameWidth, GameVars.gameHeight, 0x000000, .55
        ).setInteractive();
        this.panel = new Phaser.GameObjects.Container(scene);
        const background = new NineSliceContainer(
            scene, 0, 0, "texture_atlas_1", "bg_generic",
            ContractResult.WIDTH, ContractResult.HEIGHT, 48
        );
        const made = result.outcome === "made";
        const title = new Phaser.GameObjects.Text(scene, 0, -154, made ? "CONTRACT MADE" : "CONTRACT DOWN", {
            fontFamily: "Baloo2-Bold", fontSize: "42px", color: made ? "#45D483" : "#FF4D4D"
        }).setOrigin(.5);
        const contract = new ContractBid(scene, result.contract, { width: 220, height: 110 });
        contract.setY(-54);
        const declarer = new Phaser.GameObjects.Text(
            scene, 0, 22, `DECLARER: ${["NORTH", "EAST", "SOUTH", "WEST"][result.contract.declarer]}`, {
                fontFamily: "Baloo2-SemiBold", fontSize: "28px", color: "#8FC4D4"
            }
        ).setOrigin(.5);
        const requiredTricks = result.contract.level + 6;
        const difference = result.declarerTricks - requiredTricks;
        const margin = new Phaser.GameObjects.Text(
            scene, 0, 79,
            difference < 0 ? `DOWN ${-difference}` : difference > 0 ? `MADE +${difference}` : "JUST MADE", {
                fontFamily: "Baloo2-Bold", fontSize: "48px",
                color: made ? "#45D483" : "#FF4D4D"
            }
        ).setOrigin(.5);
        this.continueBtn = new Button(
            scene, 0, 160, "texture_atlas_1", matchFinished ? "btn_continue" : "btn_next_hand"
        );
        this.continueBtn.setScale(.9);
        this.continueBtn.setInflationTween(1.05, .9, .9);
        this.continueBtn.onUp(() => {
            if (!this.visible || !this.continueBtn.input?.enabled) {
                return;
            }
            this.continueBtn.disable();
            onContinue();
        }, this);
        this.panel.add([background, title, contract, declarer, margin, this.continueBtn]);
        this.add([this.backdrop, this.panel]);
        this.relayout();
    }

    public relayout(): void {

        this.setPosition(GameVars.gameWidth / 2, GameVars.gameHeight / 2);
        this.backdrop.setDisplaySize(GameVars.gameWidth, GameVars.gameHeight);
        const scale = Math.min(
            1, (GameVars.gameWidth - 32) / ContractResult.WIDTH,
            (GameVars.gameHeight - 32) / (ContractResult.HEIGHT * GameVars.scaleY)
        );
        this.panel.setScale(scale, scale * GameVars.scaleY);
    }
}
